import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";
const ImageChooser = ({name, image}) => {
    const [imageChoose, setImage] = useState(image ? image : urlStatic + "/images/noimage.png");
    const [fileName, setFileName] = useState(image ? image : "Sin imagen");
    const fileChangeHandler = (e) => {
        setImage(URL.createObjectURL(e.target.files[0]));
        setFileName(e.target.files[0].name);
    };

    return (
        <div className="image-chooser text-center">
            <div className="image-chooser-box m-auto" style={{width: "82px", border: "1px dashed black"}}>
                <img src={imageChoose} alt="logo" className="p-1" />
                <input type="file" name={name} id={name} className="d-none" onChange={fileChangeHandler} />
            </div>
            <p className="m-0">
                <small>{fileName}</small>
            </p>
            <button
                type="button"
                className="btn btn-link"
                onClick={() => document.querySelector(`input[type='file'][name=${name}]`).click()}>
                <FontAwesomeIcon icon="pen" className="text-primary" />
            </button>
        </div>
    );
};

export default ImageChooser;
